import React from 'react';

export default function DistributorSetupHeader({ onRefresh, busy, error, notice }) {
  return (
    <>
      <header className="me-distributor-admin-header flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="me-distributor-admin-eyebrow">Distributor operations</p>
          <h1 className="text-3xl font-semibold text-slate-900">Distributor setup</h1>
          <p className="mt-2 max-w-3xl text-sm text-slate-600">
            Create a distributor with its own customer list and portal logins, separate from direct
            MedEffects accounts. No order is sent by setup.
          </p>
        </div>
        <button
          type="button"
          onClick={onRefresh}
          disabled={busy}
          className="me-distributor-admin-secondary"
        >
          Refresh list
        </button>
      </header>
      {error && (
        <p role="alert" className="text-red-700">
          {error}
        </p>
      )}
      {notice && (
        <p role="status" className="text-green-700">
          {notice}
        </p>
      )}
    </>
  );
}
